import { createSearchFriendlyString } from '@utils/common';

function filterComponentEntry(state, componentEntry) {
  const needle = createSearchFriendlyString(state.query);
  const haystack = createSearchFriendlyString(`${componentEntry.component.title} ${componentEntry.product?.title} ${"student" in componentEntry ? componentEntry.student.name : ""} ${"student" in componentEntry ? componentEntry.student.team : ""}`);
  const matchesQuery = haystack.includes(needle);
  const matchesProductFilter = state.filters.productIds[componentEntry.product?.id ?? ""] || Object.keys(state.filters.productIds).length === 0;
  if ("student" in componentEntry) {
    const matchesTeamFilter = state.filters.teamIds[componentEntry.student.team] || Object.keys(state.filters.teamIds).length === 0;
    const matchesStudentFilter = state.filters.studentIds[componentEntry.student.id] || Object.keys(state.filters.studentIds).length === 0;
    return matchesQuery && matchesProductFilter && matchesTeamFilter && matchesStudentFilter;
  } else {
    return matchesQuery && matchesProductFilter;
  }
}

export { filterComponentEntry };
//# sourceMappingURL=filter.js.map
